import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import PropTypes from "prop-types";
import Select from "react-select";
import {Button, ButtonGroup} from "reactstrap";
import moment from "moment"
import Parts from "../Parts";
import {isDirtySafe, setTimestamp} from "../../constants/Utilities";
import {feBookableTodayFilter} from "../../constants/feBookable";

/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has
 */
export default class Ticket extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Tickets._name);
		this.state.tickets_notess = [];
		this.state.field_engineer = null;
		if (props.customer) this.model.object.customer = props.customer;
		if (props.location) this.model.object.location = props.location;
		this.redirect = this.props.baseUrl;
		this.clearFields = this.clearFields.bind(this);
		this.state.startAppt = null;
		this.state.endAppt = null;
		this.state.noTime = false;
	}

	clearFields() {
		this.setState({summary: "", type: [], description: ""});
	}

	loadSelfBefore = async (data) => {
		let {onData} = this.props;

		if (typeof onData === "function") onData(data);

		return data;
	};

	componentDidMount() {
		super.componentDidMount();
		if (this.props.clear) {
			this.props.clear(this.clearFields);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		//check if something has changed and if it has then update the timestamp used for delaying the idle modal
		const isDirty = isDirtySafe(prevState, this.state, ['summary', 'type', 'description'])
		if (isDirty) {
			setTimestamp('lastSync')
		}
	}

	async handleSubmit(event, suppressToast = false, suppressProcess = false) {
		if (this.state.startAppt && this.state.endAppt)
		{
			await super.handleSubmit(event, suppressToast, suppressProcess);
		}
		else {
			this.setState({noTime: true})
		}
	}

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		if (property === 'type' && typeof(this.props.updateTicketType) !== 'undefined') {
			this.props.updateTicketType(value);
		}
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				this.setState({
					[linked]: object,
					[property]: value,
					[property + '_error']: '',
					[property + '_binary_id']: object.binary_id,
					[property + '_binary_id_error']: '',
				});
			} else {
				if( this.state.hasOwnProperty(property + '_binary_id')) {
					this.setState({
						[linked]: object,
						[property]: value,
						[property + '_error']: '',
						[property + '_binary_id']: null,
						[property + '_binary_id_error']: '',
					});
				} else {
					this.setState({
						[linked]: object,
						[property]: value,
						[property + '_error']: '',
					});
				}
			}
		} else {
			if( this.state.hasOwnProperty(property + '_binary_id')) {
				this.setState({
					[property]: value,
					[property + '_error']: '',
					[property + '_binary_id']: null,
					[property + '_binary_id_error']: '',
				});
			} else {
				this.setState({
					[property]: value,
					[property + '_error']: '',
				});
			}
		}
	};

	form = () => {
		/**
		 * @param {Tickets_Properties} data
		 */
		let {properties} = this.model;
		/**
		 * @type {Tickets_Object} object
		 */
		let object = this.state;
		let {loading, days} = this.state;
		return (
			<div>
				<fieldset>
					<div className={'section-title'}>
						<h4 className="section-title">Ticket Entry</h4>
						<div className={'flex-end text-right align-self-center pr-1'} style={{gap: '5px', display: 'flex', alignItems: 'center'}}>
							<Parts.FDCountDisplay type={'dispatch'} count={this.props.dispatch_count} triggerModal={this.props.triggerFDGraphModal}/>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-md-8"}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Summary of Work"}
									value={object.summary}
									error={object.summary_error}
									property={properties.summary}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>

						{!this.props.hideFE && <div className={"col-md-4"}>
							<div className="form-group">
								<Framework.Elements.Select
									objectKey={this.props.location}
									shouldLoad={true}
									property={properties.field_engineer}
									value={object.field_engineer}
									error={object.field_engineer_error}
									object={object.field_engineers}
									update={this.handleSelectPropertyUpdate}
									groupBy={(option) =>
										option.original.region
											? option.original.regions.name
											: "No Region"
									}
									requestOverride={"GET_FIELD_ENGINEERS"}
									filter={feBookableTodayFilter}
									defaultGroup={this.props.location}
									limit={null}
									sort={"ranking"}
									text={"name_first&name_last"}
									showToolTip={true}
									default={""}
									groupSort={(option) => option.original?.regions ? option.original.regions.ranking : 100}
								/>
							</div>
						</div>
						}
						<div className={"col-md-4"}>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									property={properties.type}
									value={object.type}
									error={object.type_error}
									object={object.tickets_types}
									update={this.handleSelectPropertyUpdate}
									order={"ASC"}
								/>
							</div>
						</div>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.description}
							value={object.description}
							error={object.description_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		);
	};
}
